// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__o1SnZ","inner":"Footer_inner__qUeKy"};